import React from 'react'
import Dialog from '../../../common/Dialog'
import $t from '../../../../i18n'
import { Button } from 'antd'
import { getContactSupportUrl } from '../../../../consts'
import { useSelector } from 'react-redux'
import { getIsHmoMember } from '../../../../utils/hmoUtils'

import './UnsupportedStateDialog.css'

const UnsupportedStateDialog = ({
  state,
  setUnsupportedDialog,
  unsupportedDialog,
}) => {
  const userDetails = useSelector(state => state.profile?.userDetails)
  const isHmoMember = getIsHmoMember(userDetails)
  const onCloseDialog = () => {
    setUnsupportedDialog(false)
    window.open(getContactSupportUrl(isHmoMember), '_self')
  }
  const renderDialogFooter = () => (
    <Button type="primary" onClick={onCloseDialog}>
      {$t('pages.paymentplan.unsupportedState.continue')}
    </Button>
  )
  const renderContent = () => (
    <span className="unsupported-dialog-content">
      {$t('pages.paymentplan.unsupportedState.desc', {
        state: state
          ? state
          : $t('pages.paymentplan.unsupportedState.yourState'),
      })}
    </span>
  )
  return (
    <>
      {' '}
      <Dialog
        title={$t('pages.paymentplan.unsupportedState.title')}
        isVisible={unsupportedDialog}
        footerActions={renderDialogFooter()}
        className={'unsupported-dialog'}
        onCancel={onCloseDialog}
      >
        {renderContent()}
      </Dialog>
    </>
  )
}

export default UnsupportedStateDialog
